import type { HexTileCoordinates, HexTileMapKey } from './types';

function getHexTileMapKey(coordinates: HexTileCoordinates): HexTileMapKey {
  return `${coordinates.q},${coordinates.r}`;
}

export { getHexTileMapKey };
